import { ServicePageTemplate } from "@/components/services/ServicePageTemplate";
import { servicePages } from "@/data/servicePages";

const data = servicePages.find((s) => s.slug === "cipc-annual-returns")!;
const CipcAnnualReturns = () => <ServicePageTemplate data={data} />;
export default CipcAnnualReturns;
